/**
 * پایهٔ URL بک‌اند. در build با REACT_APP_API_URL تنظیم شود (بدون اسلش انتهایی).
 */
export function getApiBaseUrl() {
  const raw = process.env.REACT_APP_API_URL || 'http://localhost:5001';
  return String(raw).replace(/\/+$/, '');
}

/**
 * URL کامل برای مسیر API (با / شروع شود، مثلاً /api/auth/login)
 */
export function apiUrl(path) {
  const base = getApiBaseUrl();
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalized}`;
}

export const API_ENDPOINTS = {
  get LOGIN() {
    return apiUrl('/api/auth/login');
  },
  get REGISTER() {
    return apiUrl('/api/auth/register');
  },
  get VERIFY_OTP() {
    return apiUrl('/api/auth/verify-otp');
  },
  get BUSINESS_REGISTER() {
    return apiUrl('/api/business/register');
  },
  get BUSINESS_INFO() {
    return apiUrl('/api/business/info');
  },
  get BUSINESS_UPDATE() {
    return apiUrl('/api/business/update');
  },
  get BUSINESS_STATUS() {
    return apiUrl('/api/business/status');
  },
  get PRODUCT_CREATE() {
    return apiUrl('/api/product');
  },
  get PRODUCT_USER() {
    return apiUrl('/api/product/user');
  },
  PRODUCT_GET: (id) => apiUrl(`/api/product/${id}`),
  PRODUCT_UPDATE: (id) => apiUrl(`/api/product/${id}`),
  PRODUCT_DELETE: (id) => apiUrl(`/api/product/${id}`),
  get ADMIN_BUSINESSES() {
    return apiUrl('/api/admin/businesses');
  },
  get ADMIN_USERS() {
    return apiUrl('/api/admin/users');
  },
  get BLOG_CREATE() {
    return apiUrl('/api/blog');
  },
  get BLOG_LIST() {
    return apiUrl('/api/blog');
  },
  BLOG_GET: (id) => apiUrl(`/api/blog/${id}`)
};

const defaultBase = getApiBaseUrl();
export default defaultBase;
